import dayjs, { Dayjs } from "dayjs";
import { BalloonEventModel, BalloonEventsQuery } from "ts-core";
import { FilterLabelCarousel } from "../../components/FilterLabelCarousel";
import { CalendarPicker } from "../../components/CalendarPicker";
import SearchBar from "../../components/SearchBar";
import { SearchIcon } from "../../components/SearchIcon";
import { CreatorLink } from "../../components/CreatorLink";
import React from "react";
import { useIsMobile, useTheme } from "react-ui";
import { FilterPicker } from "../../components/FilterPicker.tsx";
import { ActiveFilterPills } from "../../components/ActiveFilterPills";

export interface FilterToolbarProps {
    useCategorySearch: boolean,
    useDateSearch: boolean,
    memoizedQuery: BalloonEventsQuery,
    callbackfn: (d: Date | undefined) => dayjs.Dayjs,
    selectedDates: (dates: Dayjs[]) => void,
    useTextSearch: boolean,
    loading: boolean,
    events: BalloonEventModel[],
    selectEvent: (id: string) => void,
    selectedEvent: BalloonEventModel | null,
    searchText: (text: string) => void,
    searchText1: (text: string) => void,
    showCreatorLink: boolean,
    creatorURL?: string
}

export function FilterToolbar({
    useCategorySearch,
    searchText,
    useDateSearch,
    creatorURL,
    useTextSearch,
    loading,
    searchText1,
    selectedDates,
    selectedEvent,
    events,
    selectEvent,
    showCreatorLink,
    memoizedQuery,
    callbackfn
}: FilterToolbarProps) {
    const isMobile = useIsMobile()
    const {primaryColor} = useTheme()
    const hasLeftPicker = (useDateSearch && !isMobile) || isMobile;
    const searchHighlight = memoizedQuery.text != "" && memoizedQuery.text != undefined;
    return <div className="filter-toolbar w-full flex flex-col">
        <div className="w-full flex flex-row items-center px-4 py-2">
            <div
                className="flex flex-row items-center w-full bg-white rounded-full shadow-md p-1 min-h-[48px]"
                style={{outline: searchHighlight ? `2px solid ${primaryColor}` : '1px solid #d2d6dc'}}
            >
                {useDateSearch && !isMobile && (
                    <CalendarPicker
                        selectedDates={memoizedQuery.dates?.map((d) => callbackfn(d)) || []}
                        setSelectedDates={selectedDates}
                        highlight={memoizedQuery.dates != undefined}
                        embedded
                    />
                )}
                {isMobile && (
                    <FilterPicker
                        selectedDates={memoizedQuery.dates?.map((d) => callbackfn(d)) || []}
                        setSelectedDates={selectedDates}
                        highlight={memoizedQuery.dates != undefined}
                        embedded
                    />
                )}
                {hasLeftPicker && useTextSearch && (
                    <div className="self-stretch w-px bg-gray-200 my-2 mx-1" />
                )}
                {useTextSearch && (
                    <SearchBar
                        loading={loading}
                        events={events}
                        searchText={memoizedQuery.text || ""}
                        selectEvent={selectEvent}
                        selectedEvent={selectedEvent}
                        setSearchText={searchText}
                        highlight={searchHighlight}
                        embedded
                    />
                )}
            </div>
        </div>
        {isMobile && <ActiveFilterPills />}
        {/*<div className="flex w-full justify-end mt-2">
            {showCreatorLink && <CreatorLink creatorURL={creatorURL}/>}</div>*/}
    </div>;
}